import React, { useState } from 'react';
import withAppState from '../../../mobx/withAppState'
import { Steps } from '../../../lib/constants';
import SplitBillMenu from '../../../components/SplitBillMenu';

const MiPayAtTableSplitBillMenuWrapper = (props) => {
  const [loading, setLoading] = useState(false);
  const { restaurant, tableNumber, bill } = props;

  const initiateSplit = async (numPeople) => {
    if (!!numPeople && numPeople > 1) {
      setLoading(true);
      const response = await fetch(`api/Bill/SplitTableByAmount/${bill[0].providerId}/${restaurant.id}/${tableNumber}/${numPeople}`)
      if (!response.ok) {
        setLoading(false);
        props.setErrorModalMessage("We could not complete your request");
        return;
      }

      let data;
      try {
        data = await response.json();
      } catch (err) {
        setLoading(false);
        props.setErrorModalMessage("We could not complete your request");
        return;
      }

      const { success, bills } = data;
      if (success === true) {
        props.setBill(bills);
        props.goToStepWithoutHistory(Steps.SPLIT_BILL_NAME);
      } else {
        props.setErrorModalMessage("We could not complete your request");
      }
      setLoading(false);
    }
  };

  const initiateSplitByItem = async () => {
    setLoading(true);
    const response = await fetch(`api/Bill/SplitTableByItem/${bill[0].providerId}/${restaurant.id}/${tableNumber}/`)
    if (!response.ok) {
      setLoading(false);
      props.setErrorModalMessage("We could not complete your request");
      return;
    }

    let data;
    try {
      data = await response.json();
    } catch (err) {
      setLoading(false);
      props.setErrorModalMessage("We could not complete your request");
      return;
    }

    const { success, bills } = data;
    if (success === true) props.setBill(bills);
    else props.setErrorModalMessage("We could not complete your request");
    props.updateBillTotalAndSplit();
    props.goToStepWithoutHistory(Steps.SPLIT_BILL_NAME);
  };

  const handleBackButton = () => {
    props.popStep()
  }


  return <SplitBillMenu initiateSplit={initiateSplit} initiateSplitByItem={initiateSplitByItem} handleBackButton={handleBackButton} loading={loading} />
}


export default withAppState(MiPayAtTableSplitBillMenuWrapper,
  {
    mobXProps: ({
      restaurant,
      tableNumber,
      bill,
    }) => ({
      restaurant,
      tableNumber,
      bill,
    }),
    mobXActions: ({
      setBill,
      popStep,
      updateBillTotalAndSplit,
      goToStepWithoutHistory,
      setErrorModalMessage,
    }) => ({
      setBill,
      popStep,
      updateBillTotalAndSplit,
      goToStepWithoutHistory,
      setErrorModalMessage,
    })
  }
);